import 'utils/polyfills';
import './main.less';

import React from 'react';
import { render } from 'react-dom';
import { Router } from 'react-router-dom';
import {createBrowserHistory} from 'history';

import LanguageProvider from 'components/special/LanguageProvider';
import AuthProvider from 'components/special/oAuthProvider';

import App from './App';

const history = createBrowserHistory();
const root = document.getElementById('root');

export const AUTH_URL = process.env.REACT_APP_STS_URL || '';
if (!AUTH_URL) {
  throw Error('Env settings missing REACT_APP_STS_URL parameter');
}

const authConfig = {
  authUrl: AUTH_URL,
  clientId: 'Innheimtukerfi',
  scope: 'profile openid offline_access creditinfo collectionsystemapi sharedapi',
  secret: 'CollectionSystemClientClientAccessKey2017'
};

const main = (
  <Router history={history}>
    <AuthProvider authConfig={authConfig} history={history} restrict>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </AuthProvider>
  </Router>
);

render(main, root);
